
const baseUrl = window.Config.production? 'https://img1.daumcdn.net/thumb' : 'https://beta.daumcdn.net/thumb'

class Thumbnail {
	static make(type, url) {
		return `${baseUrl}/${type}/?scode=mtistory2&fname=${encodeURIComponent(url)}`
	}
}

export default Thumbnail
